import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { CarouselConfigDialogComponent } from '../carousel-config-dialog/carousel-config-dialog.component';

@Component({
  selector: 'app-settings-dialog',
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.sass']
})
export class SettingsDialogComponent implements OnInit {
  data: any = {};

  constructor(
    public dialogRef: MatDialogRef<SettingsDialogComponent>,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  openCarouselConfig(): void {
    const carouselDialogRef = this.dialog.open(CarouselConfigDialogComponent, {
      width: '80%',
      maxWidth: '1200px',
      disableClose: false,
      data: {}
    });

    carouselDialogRef.afterClosed().subscribe(result => {
      if (result && result.refreshCarousel) {
        this.dialogRef.close({ refreshCarousel: true });
      }
    });
  }
} 